import * as React from 'react';

import { Scroller } from '../../utils/scroller';

export type FragmentId = 'jks' | 'offices' | 'about';

export const FragmentTypes = {
  About: 'about' as FragmentId,
  Jks: 'jks' as FragmentId,
  Offices: 'offices' as FragmentId,
};

interface IFragmentProps {
  name: FragmentId;
  children: React.ReactNode;
  offset?: number;
  hash: string;
}

const scroller = new Scroller<FragmentId>({
  disableNativeScrollRestoration: true,
});

export class ScrollFragment extends React.PureComponent<IFragmentProps, object> {
  private node: HTMLElement | null;

  public componentDidMount() {
    if (!this.node) {
      throw new Error('node has no linked');
    }

    const { hash, name } = this.props;

    scroller.registerFragment({
      name,
      node: this.node,
      offset: this.props.offset || 0,
    });

    if (hash === name) {
      scroller.scrollTo(name, 0).catch(err => console.error(err));
    }
  }

  // TODO выпилить
  // eslint-disable-next-line react/no-deprecated
  public componentWillReceiveProps(newProps: IFragmentProps) {
    const hashChanged = newProps.hash !== this.props.hash;
    const isThisFragmentsHash = this.props.name === newProps.hash;

    if (hashChanged && isThisFragmentsHash && !scroller.fragmentInViewport(this.props.name)) {
      scroller.scrollTo(this.props.name).catch(err => console.error(err));
    }
  }

  public render() {
    return <div ref={node => (this.node = node)}>{this.props.children}</div>;
  }
}

interface ILinkProps {
  to: FragmentId;
  hash: string;
  children: React.ReactNode;
  className?: string;
  onHashChange(hash: string): void;
}

export class HeaderLink extends React.PureComponent<ILinkProps, object> {
  public componentDidMount() {
    window.addEventListener('scroll', this.updateHash);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.updateHash);
  }

  public render() {
    const { className, children, to } = this.props;

    return (
      <a href={`#${to}`} className={className} onClick={this.onClick}>
        {children}
      </a>
    );
  }

  private onClick = () => {
    scroller.scrollTo(this.props.to).catch(err => console.error(err));
    this.props.onHashChange(this.props.to);
  };

  private updateHash = () => {
    const { to, hash } = this.props;

    if (hash !== to && scroller.fragmentInViewport(this.props.to)) {
      this.props.onHashChange(this.props.to);
      window.location.hash = to;
    }
  };
}
